module.exports = __webpack_public_path__ + "img/e_1_12_g.ecec28ca.png";